'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionOutcome', ['$scope', function ($scope) {
        $scope.resetInspection();
        $scope.isDeficienciesOpen = true;
        $scope.isTransactionsOpen = true;
        $scope.isFeesOpen = true;

        $scope.deficiencyColumns = [
            {
                label: 'Deficiency',
                field: 'deficiency.question'
            },
            {
                label: 'Note',
                field: 'note'
            }
        ];

        $scope.transactionColumns = [
            {
                label: 'Transaction',
                field: 'transaction_number'
            },
            {
                label: 'Amount Paid',
                field: 'itemized_amount'
            }
        ];

        $scope.feeColumns = [
            {
                label: 'Fee',
                field: 'name',
                link: {
                    state: 'internal.inspecting.inspection.fee',
                    params: [
                        {
                            name: 'inspectionFeeID',
                            field: 'id'
                        },
                        {
                            name: 'inspection_fee',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Amount',
                field: 'value'
            }
        ];

        $scope.calculateTotalFees = function (checklistFee, extraFees) {
            var extraFeeTotal = 0;
            for (var fee in extraFees) {
                if (extraFees[fee].value != null) {
                    extraFeeTotal = extraFeeTotal + extraFees[fee].value;
                }
            }
            return Math.max(extraFeeTotal + checklistFee, 0);
        }
    }])
;